import type { StatusTrackerStepData } from '@/components/common';
import i18n from '@/i18n';

/** weekReportId je zaključavanje na aktivnosti — NULL/undefined = "Evidentirano" (editabilno), postavljeno = "U izvještaju" (trajno zaključano). */
export const activityLockConfig = {
  recorded: {
    labelKey: 'activities.status.recorded',
    bg: 'var(--color-status-success-soft)',
    fg: 'var(--color-status-success)'
  },
  locked: {
    labelKey: 'activities.status.inReport',
    bg: 'var(--color-status-warning-soft)',
    fg: 'var(--color-status-warning)'
  }
};

export const activityLockState = (weekReportId?: string) =>
  weekReportId ? activityLockConfig.locked : activityLockConfig.recorded;

/**
 * Koraci za StatusTracker (Figma node 4859:13767) — Aktivnost formalno nema statusni tijek
 * (Figma dokumentacija za Status Tracker to izričito navodi), pa je ovo minimalan tracker izveden
 * iz jedinog stvarnog signala koji Activity ima — weekReportId (isti podatak kao badge iznad,
 * activityLockState) — bez izmišljanja bogatijeg tijeka koji podaci ne podržavaju.
 */
export const buildActivityTrackerSteps = (weekReportId?: string): StatusTrackerStepData[] => {
  const t = i18n.t.bind(i18n);
  const isLocked = !!weekReportId;
  return [
    {
      key: 'recorded',
      label: t('activities.status.recorded'),
      state: isLocked ? 'done' : 'current'
    },
    {
      key: 'inReport',
      label: t('activities.status.inReport'),
      state: isLocked ? 'current' : 'upcoming'
    }
  ];
};
